/** Feature-local TanStack QueryClient per admin-reconciliation (F-009.5). */
import { QueryClient } from '@tanstack/react-query';

export function createReconciliationQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
      mutations: { retry: 0 },
    },
  });
}

export const reconciliationQueryClient = createReconciliationQueryClient();
